import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/reporteCiudadano.css';

const PublicLayout = ({ children }) => {
    return (
        <div className="public-layout">
            <header className="public-header">
                <div className="public-header-content">
                    <Link to="/reporte-ciudadano" className="public-logo">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                            <polyline points="9 22 9 12 15 12 15 22"/>
                        </svg>
                        <span>Reporte Gobernador</span>
                    </Link>
                    <nav className="public-nav">
                        <Link to="/reporte-ciudadano" className="public-nav-link">Nuevo Reporte</Link>
                        <Link to="/reporte-ciudadano/seguimiento" className="public-nav-link">Seguimiento</Link>
                    </nav>
                </div>
            </header>
            <main className="public-main">
                {children}
            </main>
            <footer className="public-footer">
                <p>Sistema de Parques para Todos - Reportes Ciudadanos</p>
            </footer>
        </div>
    );
};

export default PublicLayout;
